<template>
    <div class="cases-item">
        <a :href="caseItem.Url" class="cases-item__link-wrap">
            <div class="cases-item__inner">
                <div class="cases-item__image-wrap">
                    <ResponsiveImage v-if="caseItem.ImageHtml.Src || caseItem.ImageHtml.HasCrop" :imageModel="caseItem.ImageHtml" wrapClass="cases-item__image" />
                </div>
                <div class="cases-item__text">
                    <div class="cases-item__text-row">
                        <p class="cases-item__preheadline" v-if="caseItem.HasSegments"
                            :style="{ color: caseItem.Segments[0].Color }">{{ caseItem.Segments[0].Label }}</p>
                        <h3 class="cases-item__headline">{{ caseItem.Headline }}</h3>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import ResponsiveImage from "./responsiveImage.vue";

export default {
    name: "caseItem",
    components: {
        ResponsiveImage
    },
    props: ["caseItem"]
};
</script>